import { UserContextFilters, UsersCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function UserFilterControl({
  placeholder,
  contextFilters,
}: {
  placeholder?: string
  contextFilters?: UserContextFilters
}) {
  const { onSelect, selection } = useFilterMutator()
  return (
    <UsersCommandList
      multiselect
      selected={selection}
      placeholder={placeholder}
      onSelect={onSelect}
      contextFilters={contextFilters}
    />
  )
}
